import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'app/@core/lib/global';

@Component({
  selector: 'home-platform-change',
  templateUrl: './home-platform-change.component.html',
  styleUrls: ['./home-platform-change.component.scss']
})
export class HomePlatformChangeComponent implements OnInit {

  @Input() platform: string;

  public platforms = [
    {
      id: 'custom',
      name: 'Configurar Sistema',
      url: `/editor/custom`
    },
    {
      id: 'trail',
      name: 'Criar Conteúdo',
      url: `/gerenciadores`
    },
    {
      id: 'ead',
      name: 'Editar Layout',
      url: `/editor/ead`
    },
    {
      id: 'registration',
      name: 'Cadastrar usuários',
      url: `/cadastros`
    }
  ]

  constructor(
    public global: Global,
    public router: Router
  ) {

  }

  ngOnInit() {

  }

  public get url() {
    return this.router.url;
  }

  public goto(url) {
    if (url.includes('/editor/custom')) {
      this.global.startLoading('Acessando Editor...');
      setTimeout(() => {
        let token = sessionStorage.getItem('token') || '';
        token = token.replace('Bearer ', '');
        window.location.href = `https://admin.hmgasap.com.br${url}/redirect?token=${token}`;
      }, 200);
    }
    else if (url.includes('/editor/')) {
      this.global.startLoading('Acessando Editor...');
      setTimeout(() => {
        window.location.href = url;
      }, 200);
    }
    else {
      this.router.navigateByUrl(url);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/modules/shared/home-platform-change/home-platform-change.component.ts